export default __webpack_public_path__ + "static/media/delete-btn-concierge.5a977d46.png";